import React, { useState } from 'react';
import axios from 'axios';
import { Send, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const inputCls =
  'w-full bg-[#FAF9F7] border border-[#EFE6E9] rounded-lg px-4 py-3 text-sm text-[#2C2C2C] placeholder-[#C0B9B0] focus:outline-none focus:border-[#DE92A9] focus:ring-2 focus:ring-[#DE92A9]/20';

const PartnerEnquiryForm = ({ partner, slug }) => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', wedding_date: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/api/partners/enquiries`, {
        ...form,
        partner_slug: slug,
        partner_name: partner.name,
      });
      setSent(true);
      toast.success(`Your enquiry to ${partner.name} is on its way`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center py-10" data-testid="partner-enquiry-success">
        <CheckCircle2 size={40} className="mx-auto mb-4" style={{ color: '#DE92A9' }} />
        <p className="text-xl mb-2" style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}>Enquiry sent</p>
        <p className="text-sm" style={{ color: '#757B7F' }}>
          We have passed your message to {partner.name}. Expect a reply within a few days.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="partner-enquiry-form">
      <input required value={form.name} onChange={update('name')} placeholder="Your name(s)" className={inputCls} data-testid="enquiry-name-input" />
      <input required type="email" value={form.email} onChange={update('email')} placeholder="Email address" className={inputCls} data-testid="enquiry-email-input" />
      <div className="grid grid-cols-2 gap-3">
        <input value={form.phone} onChange={update('phone')} placeholder="Phone (optional)" className={inputCls} data-testid="enquiry-phone-input" />
        <input value={form.wedding_date} onChange={update('wedding_date')} placeholder="Wedding date" className={inputCls} data-testid="enquiry-date-input" />
      </div>
      <textarea
        required
        rows={4}
        minLength={10}
        value={form.message}
        onChange={update('message')}
        placeholder={`Tell ${partner.name} about your wedding: venue, guest numbers, what you are looking for...`}
        className={`${inputCls} resize-none`}
        data-testid="enquiry-message-input"
      />
      <button
        type="submit"
        disabled={sending}
        className="w-full inline-flex items-center justify-center gap-2 text-white text-xs tracking-[0.2em] font-semibold px-6 py-4 rounded-full transition-all hover:tracking-[0.25em] disabled:opacity-60"
        style={{ backgroundColor: '#DE92A9' }}
        data-testid="enquiry-submit-btn"
      >
        <Send size={14} />
        {sending ? 'SENDING...' : 'SEND ENQUIRY'}
      </button>
      <p className="text-[11px] text-center leading-relaxed" style={{ color: '#A0978A' }}>
        Your enquiry is forwarded by I DO to {partner.name}. See our <a href="/privacy-policy" className="underline">privacy policy</a>.
      </p>
    </form>
  );
};

export default PartnerEnquiryForm;
